import * as React from 'react'
import ChevronDownIcon from '~/components/job_search/JobSearchPage/ChevronDownIcon'
import { useTranslation } from '~/hooks/useTranslation'
import { Button } from '~/lib/ui/button'
import { cn } from '~/lib/utils'

export function DetailsCell({ row }) {
  const { t } = useTranslation('DetailsCell')
  const feedback = row.original
  const candidateMessage = feedback.content?.message
  const coachMessage = feedback.content?.coach_message

  const expandText = row.getIsExpanded() ? t('close') : t('view')

  const expandable = candidateMessage || coachMessage

  return (
    <div className="flex flex-col gap-1 pr-2">
      <div className="flex flex-row items-center gap-1 text-sm">
        <div className="flex flex-col">
          {expandable && (
            <Button
              variant="coachcta"
              className="w-48 text-base"
              {...{ onClick: row.getToggleExpandedHandler() }}
            >
              {expandText}
              <ChevronDownIcon
                className={cn(
                  'ml-auto inline-block h-4 w-4 stroke-2 transition-all duration-500',
                  row.getIsExpanded() && 'rotate-180',
                )}
              />
            </Button>
          )}
          {!expandable && <div>{t('no_messages')}</div>}
        </div>
      </div>
    </div>
  )
}
